// SPDX-FileCopyrightText: Copyright (c) 2025 Software GmbH, Darmstadt, Germany and/or its subsidiaries and/or its affiliates
// SPDX-FileContributor: Zead Alshukairi (planen-bauen 4.0 GmbH)
//
// SPDX-License-Identifier: Apache-2.0

import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-notification',
  imports: [TranslateModule],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnChanges {

  @Input() notification: { message: string, type: 'success' | 'error' | 'info', duration: number } | null = null;
  @Output() close = new EventEmitter<void>();

  show: boolean = true;

  /**
   * Initializes the component and sets up auto-dismiss timer.
   */
  ngOnInit() { this.showNotification(); }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['notification']) this.showNotification();
  }

  private showNotification() {
    if (this.notification && this.notification.duration > 0) {
      setTimeout(() => {
        this.dismiss();
      }, this.notification.duration);
    }
  }

  /**
   * Dismisses the notification and emits the close event.
   */
  dismiss() {
    this.show = false;
    setTimeout(() => this.close.emit(), 300); // Wait for fade-out animation
  }

}
